import initialState from "./state";
import actions from "./actions";
import mutations from "./mutations";

export default {
    namespaced: true,
    state: initialState,
    actions,
    mutations,
};
